import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { get_company_profile_by_id } from "../../../DAL/feed/feed";
import CircularLoader from "../../../components/loader/CircularLoader";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../../hook/AdminContext";

const DirectContactDialog = ({ open, handleClose, data }) => {
  const [companyData, setCompanyData] = useState();
  const [loading, setLoading] = useState(true);

  const { handleEmailClick } = useIds();

  const fetchCompanyData = async () => {
    setLoading(true);
    const response = await get_company_profile_by_id(data?._id);
    if (response.code === 200) {
      setCompanyData(response?.user?.direct_contact || null);
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      console.error("Failed to fetch company data", response.message);
    }
  };
  useEffect(() => {
    if (data?._id && open) {
      fetchCompanyData();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Direct Contact Information
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <CircularLoader height="150px" />
        ) : (
          [
            { label: "Full Name", value: companyData.full_name },
            { label: "Job Title", value: companyData.job_title },
            {
              label: "Email Address",
              value: companyData.email_address ? (
                <span
                  // href={`https://mail.google.com/mail/?view=cm&fs=1&to=${companyData.email_address}`}
                  onClick={() => handleEmailClick(companyData.email_address)}
                  rel="noopener noreferrer"
                  style={{ textDecoration: "underline" }}
                  className="text-primary-color cursor-pointer"
                >
                  {companyData.email_address}
                </span>
              ) : (
                "N/A"
              ),
            },
            { label: "Phone Number", value: companyData.phone_number },
          ].map((item, index) => (
            <React.Fragment key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <strong
                  style={{
                    minWidth: 140,
                    textAlign: "left",
                  }}
                >
                  {item.label}
                </strong>
                <span
                  className="text-muted ms-4"
                  style={{
                    flex: 1,
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  {item.value || "N/A"}
                </span>
              </div>
              {index !== 3 && <Divider sx={{ my: 1 }} />}
            </React.Fragment>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DirectContactDialog;
